import { useAtom } from "jotai";
import { Outlet, useMatch } from "react-router-dom";

import { TwoColumnLayout } from "@/components/Layout/BaseLayouts/TwoColumnLayout";
import { LoginData } from "@/components/Portal/UserAccount/Security/LoginData";
import { MagicLinkLoginSetting } from "@/components/Portal/UserAccount/Security/MagicLinkLoginSetting";
import { useIsMobile } from "@/hooks/useIsMobile";
import { portalRoutes } from "@/router/routes/portalRoutes";
import { userAccountStateAtom } from "@/utils/atoms";

/**
 * Login-tab layout, which differs by viewport:
 *
 * - Desktop/tablet: E-Mail, Passwort, Magic-Link and the 2FA section stack in
 *   one column (left of TwoColumnLayout). The nested route (`<Outlet/>`) drives
 *   the 2FA flow inline below the login cards.
 * - Mobile: every 2FA step is its own screen. Only the active card is rendered —
 *   without the sibling cards — and `UserAccount` hides the account header,
 *   banner and tab strip to match.
 */
export const SecurityView = () => {
  const isMobile = useIsMobile();
  const [userAccountState] = useAtom(userAccountStateAtom);
  const securityMatch = useMatch(portalRoutes.user.security.base + "/*");
  const isInSubFlow = securityMatch?.pathnameBase !== securityMatch?.pathname;

  if (isMobile && isInSubFlow) {
    return <Outlet />;
  }

  // Editing the E-Mail/Passwort card is likewise a standalone mobile screen:
  // LoginData keeps only the card being edited, so the Magic-Link card has to
  // go with them.
  const isStandaloneMobileEdit =
    isMobile &&
    (userAccountState.editingMail || userAccountState.editingPassword);

  return (
    <div className="flex flex-col gap-6">
      {isStandaloneMobileEdit ? (
        <LoginData />
      ) : (
        <TwoColumnLayout
          rows={[
            {
              left: (
                <div className="flex w-full flex-col gap-6">
                  <LoginData />
                  <MagicLinkLoginSetting />
                  <Outlet />
                </div>
              ),
            },
          ]}
        />
      )}
    </div>
  );
};
